const createRootVariableName = () => `--custom-color-${Date.now()}`;

export default createRootVariableName;
